<script>
export default {
  name: "ResourcesPage",
  setup() {
    return {};
  },
};
</script>

<template>
  <div></div>
</template>

<style scoped>

</style>